import { invokeApi } from '@/common/invokeApi/invokeApi';

import { PatientWorkQueueItem } from '../PatientWorkQueue.types';

export type FetchPatientWorkQueueParams = {
  teamId?: string;
};

export const fetchPatientWorkQueue = async ({
  teamId,
}: FetchPatientWorkQueueParams) =>
  await invokeApi<PatientWorkQueueItem[]>({
    path: teamId
      ? `/patient-event-queue/teams/${teamId}`
      : '/patient-event-queue',
  });
